import 'preline';
import { initFlowbite } from 'flowbite';
import { configureHtmx } from './htmxConfig';
import { BUILD_STAMP } from './.generated/build_stamp';

declare global {
  interface Window {
    HSStaticMethods?: {
      autoInit: (collection?: string | string[]) => void;
    };
  }
}

const BUILD_STAMP_GLOBAL_KEY = '__cacWebBuildStamp';
const BUILD_STAMP_LOGGED_KEY = '__cacWebBuildStampLogged';

const announceBuildStamp = (source: string): void => {
  if (typeof window === 'undefined') {
    return;
  }
  const globalAny = window as unknown as Record<string, unknown>;
  globalAny[BUILD_STAMP_GLOBAL_KEY] = BUILD_STAMP;
  const loggedSources =
    (globalAny[BUILD_STAMP_LOGGED_KEY] as Record<string, boolean> | undefined) ?? {};
  if (loggedSources[source]) {
    return;
  }
  loggedSources[source] = true;
  globalAny[BUILD_STAMP_LOGGED_KEY] = loggedSources;
  // eslint-disable-next-line no-console
  console.warn(`[cac-web] build-stamp (${source})`, BUILD_STAMP);
};

const reinitializeUi = () => {
  initFlowbite();
  window.HSStaticMethods?.autoInit();
};

const boot = () => {
  announceBuildStamp('app.ts');
  reinitializeUi();
  configureHtmx({
    onAfterSettle: () => {
      reinitializeUi();
    },
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
